import { useQuery } from '@apollo/client/react/hooks'
import { Box, Text } from '@factorialco/deprecated-design-system'
import { AtsJobPostingPremiumPortalsDocument } from 'generated/resources/graphql'
import { orderBy, range } from 'lodash'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { JobPostingLayout } from 'modules/ats/components/job_postings/JobPostingLayout'
import { PremiumOfferEmptyState } from 'modules/ats/pages/JobPostingMarketplace/PremiumOfferEmptyState'
import { useJobDetailsContext } from 'modules/ats/pages/JobsPage/JobDetails'

import { PremiumBundleCard } from './PremiumBundleCard'
import { PremiumBundleCardSkeleton } from './PremiumBundleCard/PremiumBundleCardSkeleton'
import { PremiumProductCard } from './PremiumProductCard'
import { PremiumProductCardSkeleton } from './PremiumProductCard/PremiumProductCardSkeleton'
import { premiumBundleCardsGridStyle, premiumProductCardsGridStyle } from './index.vanilla.css'

export const JobPostingMarketplace = () => {
  const { job } = useJobDetailsContext()
  const { access } = useCurrentSession()
  const legalEntityId = job.attributes.legal_entity_id || -1
  const { data, loading } = useQuery(AtsJobPostingPremiumPortalsDocument, {
    variables: { accessId: access.id, atsJobPostingId: job.id, legalEntityId },
    skip: !job.id || !legalEntityId,
  })
  const premiumBundles = data?.integrationsJoin.premiumBundlesConnection.nodes || []
  const premiumProducts = data?.integrationsJoin.premiumProductsConnection.nodes || []
  const hasPremiumOffers = premiumBundles.length > 0 && premiumProducts.length > 0

  return (
    <JobPostingLayout job={job}>
      <Box gap="s20">
        {!loading && !hasPremiumOffers ? (
          <PremiumOfferEmptyState />
        ) : (
          <>
            {/* premium bundles */}
            <Box gap="s16">
              <Text.Normal
                weight="semibold"
                size="300"
                color="grey1000"
                title={i18n.t('ats.job_details.marketplace.bundles.title')}
              >
                {i18n.t('ats.job_details.marketplace.bundles.title')}
              </Text.Normal>
              <Box gap="s16" className={premiumBundleCardsGridStyle}>
                {loading
                  ? range(4).map((index) => (
                      <PremiumBundleCardSkeleton key={`bundle-card-skeleton-${index}`} />
                    ))
                  : orderBy(premiumBundles, ['products']).map((bundle) => (
                      <PremiumBundleCard key={`bundle-card-${bundle.id}`} bundle={bundle} />
                    ))}
              </Box>
            </Box>

            {/* premium products */}
            <Box gap="s16">
              <Text.Normal
                weight="semibold"
                size="300"
                color="grey1000"
                title={i18n.t('ats.job_details.marketplace.products.title')}
              >
                {i18n.t('ats.job_details.marketplace.products.title')}
              </Text.Normal>

              <Box gap="s16" className={premiumProductCardsGridStyle}>
                {loading
                  ? range(2).map((index) => (
                      <PremiumProductCardSkeleton key={`product-card-skeleton-${index}`} />
                    ))
                  : orderBy(premiumProducts, ['products']).map((product) => (
                      <PremiumProductCard key={`product-card-${product.slug}`} product={product} />
                    ))}
              </Box>
            </Box>
          </>
        )}
      </Box>
    </JobPostingLayout>
  )
}
